import './loginState.scss';
import React from 'react';
import { useContext } from 'react';
import { AppContext } from '../../context/appContext';
import UserAvatar from '../../common/businessCommon/user/userAvatar/userAvatar';
import UserName from '../../common/businessCommon/user/userName/userName';
export const LoginState = () => {
    const { state } = useContext(AppContext);
    const { userInfo, isInUSE, isInAITools } = state;
    return (
        <div className="loginState">
            <div className="user">
                <UserAvatar
                    src={userInfo.avatar}
                    className="data-user-avatar"
                    width={32}
                    showUserLevel={isInUSE || isInAITools ? 0 : userInfo.show_user_level}
                    userLevelInfo={userInfo.user_level}
                />
                <i className="icon icon-arrow-down"></i>
            </div>
        </div>
    );
}
